import { render, staticRenderFns } from "./CompanyDeactivated.vue?vue&type=template&id=e9e58b9a&"
import script from "./CompanyDeactivated.vue?vue&type=script&lang=ts&"
export * from "./CompanyDeactivated.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports